import React, { FormEvent, useEffect, useRef } from "react";

import useSetState from "../../../hooks/useSetState";

import { useStyle } from "./styles";

interface Props {
  value?: any;
  row: any;
  column: any;
  updateMyData: (row: any, id: any, value: any, initialValue: any) => void;
  includedInInlineEditing?: Array<string>;
}

const TableCell = ({
  value: initialValue,
  row,
  column: { id },
  updateMyData,
  includedInInlineEditing = [],
}: Props) => {
  const [{ value }, setState] = useSetState({ value: initialValue });
  const classes = useStyle();
  const textEditor: any = useRef();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    if (e?.target?.value || e?.target?.value === "") {
      setState({ value: e.target.value });
    }
  };

  const onBlur = () => {
    updateMyData(row, id, value, initialValue);
  };

  const handleEnterClicked = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (textEditor && textEditor.current) {
      return textEditor.current?.blur();
    }
    return null;
  };

  useEffect(() => {
    setState({ value: initialValue });
  }, [initialValue, setState]);

  if (!includedInInlineEditing?.includes(id)) {
    return [null, undefined].includes(value) ? "" : value;
  }

  return (
    <form onSubmit={handleEnterClicked}>
      <input
        autoComplete="off"
        value={value !== null ? value : ""}
        ref={textEditor}
        onChange={onChange}
        onBlur={onBlur}
        className={classes.input}
        disabled={!includedInInlineEditing?.includes(id)}
      />
    </form>
  );
};

export default TableCell;
